export function buildPublicProposalUrl(origin, shareToken) {
  const base = new URL('/', origin || window.location.origin);
  base.searchParams.set('publicProposal', shareToken);
  return base.toString();
}

export function buildPublicInvoiceUrl(origin, shareToken) {
  const base = new URL('/', origin || window.location.origin);
  base.searchParams.set('publicInvoice', shareToken);
  return base.toString();
}

export function buildPublicPurchaseOrderVendorUrl(origin, shareToken) {
  const base = new URL('/', origin || window.location.origin);
  base.searchParams.set('publicPOVendor', shareToken);
  return base.toString();
}

export function buildPublicPurchaseOrderClientUrl(origin, shareToken) {
  const base = new URL('/', origin || window.location.origin);
  base.searchParams.set('publicPOClient', shareToken);
  return base.toString();
}
